export default __webpack_public_path__ + "static/media/bg3.2bf3ef05.jpg";